<template>
    
    <div>

        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-6">
            <b-button v-b-modal.docSelectModal style="background-color: darkorange; border-color:darkorange" v-on:click="clearData()">Select Prescriber</b-button>

            <!-- Card stats -->
            <div class="mt-3">
                <h2 style="color:white">SELECTED PRESCRIBER: {{selectedDoc}}</h2>
            </div>
            <div class="row">
                <div class="text-white mt-2 pt-1 mr-1">Date Range:</div>
                <div>
                    <flat-picker class="form-control datepicker"
                                 v-model="startDate">
                    </flat-picker>
                </div>
                <div class="text-white mt-2 pt-1 mr-1 ml-1">To:</div>
                <div>
                    <flat-picker class="form-control datepicker"
                                 v-model="endDate">
                    </flat-picker>

                </div>
            </div>
            <div class="row pt-4">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Fills With Carepoint"
                                type="gradient-info"
                                :sub-title="companyFilledCount.toString()"
                                icon="ni ni-box-2"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fas fa-calendar-day"></i> {{companyFilledCountToday}}</span>
                            <span class="text-nowrap">Today</span>
                            <br />
                            <span class="text-success mr-2"><i class="fas fa-calendar-week"></i> {{companyFilledCountWeek}}</span>
                            <span class="text-nowrap">Last 7 Days</span>
                            <br />
                            <span class="text-success mr-2"><i class="fas fa-calendar-alt"></i> {{companyFilledCountFortnight}}</span>
                            <span class="text-nowrap">Last 14 Days</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Open PA's"
                                type="gradient-blue"
                                :sub-title="companyOpenPAs.toString()"
                                icon="ni ni-archive-2"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fas fa-paper-plane"></i> {{companyInitiatedPAs}}</span>
                            <span class="text-nowrap">Initiated</span>
                            <br />
                            <span class="text-success mr-2"><i class="fas fa-fax"></i> {{companySentToPrescriberPAs}}</span>
                            <span class="text-nowrap">Sent To Prescriber</span>
                            <br />
                            <span class="text-success mr-2"><i class="fas fa-hourglass-half"></i> {{companySubmittedPAs}}</span>
                            <span class="text-nowrap">Awaiting Insurance Response</span>

                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Approved PA's"
                                type="gradient-green"
                                :sub-title="companyApprovedPAs.toString()"
                                icon="ni ni-bold-up"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">

                            <span class="text-success mr-2"><i class="fas fa-briefcase"></i> {{companyTotalPAs}}</span>
                            <span class="text-nowrap">Total</span>
                            <br />
                            <span class="text-success mr-2"><i class="fas fa-handshake"></i> {{companyResolvedPAs}}</span>
                            <span class="text-nowrap">Determined</span>
                            <br />
                            <span class="text-success mr-2"><i class="fas fa-thumbs-up"></i> {{((companyApprovedPAs*100)/(companyResolvedPAs)).toFixed(2) + '%'}}</span>
                            <span class="text-nowrap">Determined Approval Rate</span>

                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Undetermined PA's"
                                type="gradient-orange"
                                :sub-title="companyUnresolvedPAs.toString()"
                                icon="fas fa-minus"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">

                            <span class="text-success mr-2"><i class="fas fa-minus-square"></i> {{companyAbandonedPAs}}</span>
                            <span class="text-nowrap">Abandoned By Prescriber</span>
                            <br />
                            <span class="text-success mr-2"><i class="fas fa-window-close"></i> {{companyCanceledPAs}}</span>
                            <span class="text-nowrap">Canceled</span>
                            <br />
                            <span class="text-success mr-2"><i class="fas fa-trash"></i> {{((companyUnresolvedPAs*100)/(companyTotalPAs)).toFixed(2) + '%'}}</span>
                            <span class="text-nowrap">Undetermined Rate</span>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>
        <footer class="container-fluid" style=" width:fit-content;">
            <nav class="navbar fixed-bottom" style="width:fit-content;">
                <b-button style="background-color: darkorange; border-color:darkorange; border-radius:50%" v-b-tooltip.hover id="glossaryTooltip2">PA Glossary</b-button>
                <b-tooltip target="glossaryTooltip2" triggers="hover">
                    <nobr><b>PA Statuses</b></nobr><br />
                    <nobr><b>Abandoned By Prescriber: </b> The prescriber never answered Carepoint's request for a PA</nobr><br />
                    <nobr><b>Approved: </b>The PA request has been approved by the prescriber</nobr><br />
                    <nobr><b>Canceled: </b>The PA request has been canceled by Carepoint</nobr><br />
                    <nobr><b>Denied: </b>The PA request has been denied by the prescriber</nobr><br />
                    <nobr><b>Determined PA: </b>The PA request received an answer from a prescriber</nobr><br />
                    <nobr><b>Initiated: </b> Rx which have been identified as in need of a PA</nobr><br />
                    <nobr><b>Sent To Prescriber: </b> PA forms have been filled out and sent to prescriber</nobr><br />
                    <nobr><b>Submitted: </b> Awaiting prescriber's response to a PA request</nobr><br />
                    <nobr><b>Undetermined PA: </b>The PA request did not receive an answer from a prescriber</nobr><br /><br />
                </b-tooltip>
            </nav>
        </footer>
        <!--Charts-->
        <div class="container-fluid mt--7">
            <pa-history-charts :npiNumber="npiNumber"></pa-history-charts>
            <open-pa-charts class="mt-4" :apiEndpoint="individualOpenPAEndpoint"></open-pa-charts>
            <filled-count-charts class="mt-4" :apiEndpoint="individualFilledCountEndpoint"></filled-count-charts>
            <DrugVolumeCharts class="mt-4" :apiEndpoint="individualStatsEndpoint"></DrugVolumeCharts>
            <ScriptDetailsCharts class="mt-4" :apiEndpoint="scriptEndpoint"></ScriptDetailsCharts>
            <!-- End charts-->
            <!--Tables-->
            <!--End tables-->
        </div>
        <b-modal no-close-on-backdrop
                 ref="docSelectModal"
                 id="docSelectModal"
                 title="Doctor Select"
                 @ok="submitDocSelectForm">
            <form ref="docSelectForm">
                <span>LastName, FirstName: NPI</span>
                <v-select :options="accessiblePrescribers" v-model="selectedDoc"></v-select>
            </form>
        </b-modal>

    </div>
</template>
<script>
    // Charts
    import PaHistoryCharts from '@/components/Charts/PAHistoryByNPICharts';
    import OpenPaCharts from '@/components/Charts/OpenPACharts';
    import FilledCountCharts from '@/components/Charts/FilledCountByNPICharts';
    import ScriptDetailsCharts from '@/components/Charts/ScriptDetailsCharts';
    import DrugVolumeCharts from '@/components/Charts/DrugVolumeCharts';
    import flatPicker from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import moment from 'moment'

    // Tables
    import SocialTrafficTable from './Dashboard/SocialTrafficTable';
    import PageVisitsTable from './Dashboard/PageVisitsTable';

    
    export default {
        components: {
            PaHistoryCharts,
            OpenPaCharts,
            FilledCountCharts,
            ScriptDetailsCharts,
            DrugVolumeCharts,
            flatPicker
        },
        data() {
            return {
                accessiblePrescribers: [''],
                individualStatsEndpoint: '',
                individualOpenPAEndpoint: '',
                individualFilledCountEndpoint: '',
                scriptEndpoint: '',
                npiNumber: '',
                selectedDoc: '',
                searchTerm: '',
                drugData: [],
                companyFilledCount: 0,
                companyFilledCountToday: 0,
                companyFilledCountWeek: 0,
                companyFilledCountFortnight: 0,
                companyTotalPAs: 0,
                companyAbandonedPAs: 0,
                companyApprovedPAs: 0,
                companyCanceledPAs: 0,
                companyDeniedPAs: 0,
                companyInitiatedPAs: 0,
                companySentToPrescriberPAs: 0,
                companySubmittedPAs: 0,
                startDate: moment().subtract(30, 'day').toDate(),
                endDate: moment().toDate()
            };
        },
        computed: {
            companyOpenPAs: function () {
                return this.companyInitiatedPAs + this.companySentToPrescriberPAs + this.companySubmittedPAs;
            },
            companyResolvedPAs: function () {
                return this.companyTotalPAs - this.companyOpenPAs - this.companyAbandonedPAs - this.companyCanceledPAs;
            },
            companyUnresolvedPAs: function () {
                return this.companyTotalPAs - this.companyResolvedPAs - this.companyOpenPAs;
            }
        },
        watch: {
            selectedDoc: function () {
                this.fetchData();
            },
            startDate() {
                this.validateDateRange();
                this.fetchData();
            },
            endDate() {
                this.validateDateRange();
                this.fetchData();
            }
        },
        methods: {
            clearData() {
                this.npiNumber = ''
            },
            displayDate: function (uglyDate) {
                return moment(uglyDate).format("MM/DD/YYYY").toString();
            },
            showModal() {
                this.$refs['docSelectModal'].show()
            },
            hideModal() {
                this.$refs['docSelectModal'].hide()
            },
            submitDocSelectForm() {
                    this.npiNumber = this.selectedDoc.split(': ')[1]
                    this.fetchData();
            },
            fetchData() {
                if (this.npiNumber.length < 5)
                    return null;

                this.individualStatsEndpoint = "CompanyStats/GetDrugVolumeByDay/" + this.npiNumber + "/" + moment(this.startDate).format("MM-DD-YYYY") + "/" + moment(this.endDate).format("MM-DD-YYYY");
                this.scriptEndpoint = "CompanyStats/GetScriptDetails/" + this.npiNumber + "/" + moment(this.startDate).format("MM-DD-YYYY") + "/" + moment(this.endDate).format("MM-DD-YYYY");
                this.individualOpenPAEndpoint = "CompanyStats/GetOpenPAs/" + this.npiNumber + "/" + moment(this.startDate).format("MM-DD-YYYY") + "/" + moment(this.endDate).format("MM-DD-YYYY");
                this.individualFilledCountEndpoint = "CompanyStats/GetFilledCountData/" + this.npiNumber + "/" + moment(this.startDate).format("MM-DD-YYYY") + "/" + moment(this.endDate).format("MM-DD-YYYY");


                this.axios.get(`CompanyStats/GetFilledCount/${this.npiNumber}/`+ moment(this.startDate).format("MM-DD-YYYY") + `/` + moment(this.endDate).format("MM-DD-YYYY"))
                    .then(response => {
                        this.companyFilledCount = response.data || 0;
                    })
                    .catch(error => {
                        
                    });
                this.axios.get(`CompanyStats/GetFilledCountToday/${this.npiNumber}`)
                    .then(response => {
                        this.companyFilledCountToday = response.data || 0;
                    })
                    .catch(error => {
                        
                    });
                this.axios.get(`CompanyStats/GetFilledCountWeek/${this.npiNumber}`)
                    .then(response => {
                        this.companyFilledCountWeek = response.data || 0;
                    })
                    .catch(error => {
                        
                    });
                this.axios.get(`CompanyStats/GetFilledCountFortnight/${this.npiNumber}`)
                    .then(response => {
                        this.companyFilledCountFortnight = response.data || 0;
                    })
                    .catch(error => {
                        
                    });
                this.axios.get(`CompanyStats/PAStatusCounts/${this.npiNumber}/` + moment(this.startDate).format("MM-DD-YYYY") + `/` + moment(this.endDate).format("MM-DD-YYYY"))
                    .then(response => {
                        let findStatus = function (statusName) {
                            let status = response.data.find(s => s.statusName === statusName);
                            return status ? status.count : 0;
                        };
                        this.companyTotalPAs = response.data.reduce((a, b) => a + b.count, 0);
                        this.companyAbandonedPAs = findStatus("Abandoned By Prescriber");
                        this.companyApprovedPAs = findStatus("Approved");
                        this.companyCanceledPAs = findStatus("Canceled");
                        this.companyDeniedPAs = findStatus("Denied");
                        this.companyInitiatedPAs = findStatus("Initiated");
                        this.companySentToPrescriberPAs = findStatus("Sent To Prescriber");
                        this.companySubmittedPAs = findStatus("Submitted");
                    })
                    .catch(error => {
                        
                });
            },
            validateDateRange() {
                if (moment(this.endDate).diff(this.startDate, 'days') < 0) {
                    this.invalidDateToast("End Date Cannot Be Before Start Date:  End Date Has Been Set Equal To Start Date");
                    this.endDate = moment(this.startDate).toDate();
                }
                if (moment(this.endDate).diff(this.startDate, 'days') > 90) {
                    this.invalidDateToast("Maximum Date Range is 90 Days:  End Date Has Been Set To 90 Days After Start Date");
                    this.endDate = moment(this.startDate).add(90, 'day').toDate();
                }
            },
            invalidDateToast(msg) {
                this.$bvToast.toast(msg, {
                    title: 'Date Error',
                    autoHideDelay: 5000
                });
            }

        },
        mounted() {
            this.axios.get(`CompanyStats/GetAccessiblePrescribers`)
                .then(response => {
                    this.accessiblePrescribers = response.data
                    this.selectedDoc = this.accessiblePrescribers[0]
                })
                .catch(error => {
                    
                });
            this.showModal()
        }
    };
</script>
<style>
    .tooltip .tooltip-inner {
        max-width: 600px !important;
        text-align: left;
    }

    .btn-circle {
        border-radius: 50%;
    }
</style>
